import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Stack,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import styled from 'styled-components';
import { useSimpleForm } from 'utils/form';
import { tc } from 'utils/theme';
import { AppContext } from 'contexts/AppContext';
import { authenticateUser } from 'services/authService';
import Form from 'components/Atoms/Form';
import TextInput from 'components/Molecules/TextInput';
import Alert from 'components/Atoms/Alert';
import Logo from 'components/Atoms/Logo';
import Link from 'components/Atoms/Link';
import messages from 'components/Molecules/HavingTroubleLoggingInModal/messages';
import { useLegacyMode } from './hooks';
// Form Schema
import schema from './schema';

const LoginLogo = styled(Logo)`
  width: 100%;
  height: 140px;
`;

const LogoWrapper = styled.div`
  cursor: pointer;
  @media (hover: hover) {
    &:hover {
      opacity: 0.9;
    }
  }
`;

const FormWrapper = styled.div`
  background-color: ${tc('backgroundColor')};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0898154);
  border-radius: 5px;
  padding: 30px;
`;

const GridForm = styled(Form)`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px 0;
`;

const LegacyModeIndicator = styled.div`
  background-color: ${tc('warningBackground')};
  color: ${tc('warning')};
  padding: 8px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  text-align: center;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
`;

const FormLogin = ({ onSubmitSuccess, handleOpenTroubleLoggingInModal }) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const { isLegacyMode, toggleLegacyMode, handleTouch } = useLegacyMode(true);

  const onSubmit = async (v) => authenticateUser(organizationId, propertyId, v);

  const {
    handleSubmit,
    status: { isSubmitting, formErrors, serverError },
  } = useSimpleForm(schema, onSubmit, onSubmitSuccess);

  const RenderAlert = () => {
    if (isSubmitting === false && serverError) {
      return <Alert type="error">{serverError}</Alert>;
    }
    return null;
  };

  return (
    <FormWrapper>
      <LogoWrapper onClick={handleTouch}>
        <LoginLogo padBottom />
      </LogoWrapper>
      {isLegacyMode && (
        <LegacyModeIndicator onClick={toggleLegacyMode}>
          Portal - Legacy Mode
        </LegacyModeIndicator>
      )}
      <GridForm onSubmit={handleSubmit}>
        <RenderAlert />
        <TextInput
          name="emailAddress"
          label="Email"
          placeholder="Email"
          type="email"
          autoComplete="on"
          error={formErrors.emailAddress}
        />
        <TextInput
          name="password"
          label="Password"
          placeholder="Password"
          type="password"
          error={formErrors.password}
        />
        <Stack direction={'row'} spacing={1} justifyContent={'space-between'}>
          <Link onClick={handleOpenTroubleLoggingInModal}>
            {messages.loginTitle}
          </Link>
          <Link to={`/${organizationId}/${propertyId}/forgot-password`}>
            Forgot Password?
          </Link>
        </Stack>
        <Button
          variant={'primary'}
          type="submit"
          disabled={isSubmitting}
          sx={{ minWidth: 200, margin: 'auto' }}
        >
          Sign In
        </Button>
      </GridForm>
    </FormWrapper>
  );
};

FormLogin.propTypes = {
  onSubmitSuccess: PropTypes.func,
  onSubmitFailure: PropTypes.func,
};

FormLogin.defaultProps = {
  onSubmitSuccess: () => {},
  onSubmitFailure: () => {},
};

export default FormLogin;
